import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Modal, Field, inputCls, Btn, ConfirmDialog, AdminImageUpload } from "./kit";

const CATS = ["WAREHOUSE", "COFFEE BEANS", "FARM", "PROCESSING", "QUALITY CONTROL", "PACKAGING", "EXPORT", "SHIPMENT"];
const EMPTY = { image: "", category: "WAREHOUSE", title: "", description: "", date: "" };

export default function AdminGallery() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [confirm, setConfirm] = useState(null);

  const load = async () => { try { const r = await api.get("/admin/gallery"); setItems(r.data); } catch (e) {} };
  useEffect(() => { load(); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.image) { toast.error("Please upload an image"); return; }
    try { await api.post("/admin/gallery", form); toast.success("Added"); setModal(false); setForm(EMPTY); load(); } catch (e) { toast.error("Failed"); }
  };
  const del = async () => { try { await api.delete(`/admin/gallery/${confirm}`); toast.success("Deleted"); setConfirm(null); load(); } catch (e) { toast.error("Failed"); } };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div><h1 className="font-display text-2xl font-extrabold text-offwhite">Gallery</h1><p className="mt-1 font-body text-sm text-offwhite/55">Upload and categorize photos.</p></div>
        <Btn onClick={() => { setForm(EMPTY); setModal(true); }} data-testid="add-gallery-btn"><Plus className="mr-1 inline h-4 w-4" /> Add Image</Btn>
      </div>
      {items.length === 0 ? <div className="rounded-xl border border-dashed border-offwhite/15 py-16 text-center font-body text-sm text-offwhite/40">No gallery images yet.</div> : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {items.map((it) => (
            <div key={it.id} className="group relative overflow-hidden rounded-xl border border-offwhite/10 bg-[#101c14]">
              <img src={it.image} alt={it.title} className="aspect-square w-full object-cover" />
              <div className="p-3"><div className="font-mono text-[9px] uppercase text-amber-soft">{it.category}</div><div className="truncate font-body text-xs text-offwhite/80">{it.title}</div></div>
              <button onClick={() => setConfirm(it.id)} data-testid={`delete-gallery-${it.id}`} className="absolute right-2 top-2 rounded-full bg-rose-600 p-1.5 text-white opacity-0 transition-opacity group-hover:opacity-100"><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          ))}
        </div>
      )}
      <Modal open={modal} onClose={() => setModal(false)} title="Add Gallery Image">
        <div className="space-y-4">
          <AdminImageUpload value={form.image} onChange={(v) => set("image", v)} testId="gallery-image-upload" />
          <Field label="Category"><select className={inputCls} value={form.category} onChange={(e) => set("category", e.target.value)}>{CATS.map((c) => <option key={c} value={c}>{c}</option>)}</select></Field>
          <Field label="Title"><input className={inputCls} value={form.title} onChange={(e) => set("title", e.target.value)} /></Field>
          <Field label="Description"><textarea rows={2} className={inputCls} value={form.description} onChange={(e) => set("description", e.target.value)} /></Field>
          <Field label="Date"><input type="date" className={inputCls} value={form.date} onChange={(e) => set("date", e.target.value)} /></Field>
          <div className="flex justify-end gap-3"><Btn variant="ghost" onClick={() => setModal(false)}>Cancel</Btn><Btn onClick={save} data-testid="save-gallery-btn">Save</Btn></div>
        </div>
      </Modal>
      <ConfirmDialog open={!!confirm} onClose={() => setConfirm(null)} onConfirm={del} message="Delete this image?" />
    </div>
  );
}
